import { FC, SyntheticEvent } from "react";
import { Tab, Tabs, styled } from "@mui/material";
import './CustomTab.scss';

type CustomTabType = {
    activeTab: number;
    handleChangeTab: (_e: SyntheticEvent, index: number ) => void;
    labels: string[];
}

const CustomTabStyled = styled(Tab)(({ theme }) => ({
    fontFamily: 'var(--font-inter)',
    fontWeight: 600,
    fontSize: 14,
    lineHeight: '16.94px',
    textTransform: 'capitalize',
    padding: '0 var(--padding-3xs)',
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '&.Mui-selected': {
      color: 'black',
    },
    '&:not(.Mui-selected)': {
      color: 'black',
    },
}));

const CustomTab: FC<CustomTabType> = ({ activeTab, handleChangeTab, labels }) => {
    return (
        <Tabs
            className={labels?.includes('Assignment') ? 'AssignmentTabsMainContainerHeader':'TabsMainContainerHeader'}
            value={activeTab}
            onChange={handleChangeTab}
            variant="fullWidth"
            TabIndicatorProps={{
                style: {
                backgroundColor: 'transparent',
                height: '3px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
                },
                children: <span className="MuiTabs-indicatorSpan" />
            }}
            >
            {(labels.length > 0) && labels.map((label: string, index: number) => (
                <CustomTabStyled key={index} className='TabHeaderItems' label={label} />
            ))}
        </Tabs>
    );
}

export default CustomTab;
